import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {ProjectChooserComponent} from "./projectchooser.component";
import {UserDropdownComponent} from "./user-dropdown.component";
import {HelpDropdownComponent} from "./helpdropdown.component";
import {WebmateAdminDropdownComponent} from "./wmadmin-dropdown.component";
import {WebmateComponent} from "./webmate.component";
import {RouterModule} from "@angular/router";
import {AvatarModule} from "../shared/components/avatar/avatar.module";
import {ToastModule} from 'primeng/toast';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {SidebarRightModule} from "@webmate-web-core/shared/components/sidebarright/sidebarright.module";
import {UserNotificationsComponent} from "@webmate-web-core/navigation/usernotifications.component";
import {ButtonModule} from "primeng/button";
import {PopoverModule} from 'primeng/popover';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule} from '@angular/forms';
import {ToolsModule} from '@webmate-web-core/shared/tools/tools.module';
import {InternalSupportComponent} from "@webmate-web-core/navigation/internal-support.component";
import {TooltipModule} from "primeng/tooltip";
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {MarketplaceModule} from '@webmate-web-core/marketplace/marketplace.module';

@NgModule({
    declarations: [
        UserNotificationsComponent,
        ProjectChooserComponent,
        UserDropdownComponent,
        HelpDropdownComponent,
        InternalSupportComponent,
        WebmateAdminDropdownComponent,
        WebmateComponent
    ],
    imports: [
        CommonModule,
        ToolsModule,
        AvatarModule,
        ToastModule,
        RouterModule,
        FontAwesomeModule,
        SidebarRightModule,
        ButtonModule,
        PopoverModule,
        DialogModule,
        InputTextModule,
        FormsModule,
        TooltipModule,
        IconField,
        InputIcon,
        MarketplaceModule,
    ],
    exports: [
        ProjectChooserComponent,
        UserDropdownComponent,
        HelpDropdownComponent,
        InternalSupportComponent,
        WebmateAdminDropdownComponent,
        WebmateComponent
    ]
})
export class NavigationModule { }
